import { AlertModalOptions } from 'redux/mode/reducers';
import Modal from '..';
import { showAlertModal } from 'redux/mode/actions';
import { useDispatch } from 'react-redux';

interface AlertModalProps {
	options: AlertModalOptions;
}

const AlertModal = ({ options }: AlertModalProps) => {
	const { title, submitLabel, description, onSubmit } = options;
	const dispatch = useDispatch();

	const onKeyPress = (e: React.KeyboardEvent<HTMLElement>) => {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault();
			submit();
		}
	};

	const submit = () => {
		dispatch(showAlertModal(null));
		onSubmit();
	};

	const onClickOutside = (e: { preventDefault: () => void }) => {
		e.preventDefault();
		dispatch(showAlertModal(null));
	};

	return (
		<div onKeyDownCapture={onKeyPress}>
			<Modal
				disabled={false}
				submitLabel={submitLabel}
				title={title}
				description={description}
				onSubmit={submit}
				onClickOutside={onClickOutside}
			/>
		</div>
	);
};

export default AlertModal;
